export const FOOTER_LANG_MODAL_OPEN_GTM = ["Footer", "clicked", "OpenModal"];
export const FOOTER_LANG_MODAL_OPEN_MP = "footer_lang_modal_open";

export const TOP_MENU_LANG_MODAL_OPEN_GTM = ["TopMenu", "clicked", "OpenModal"];
export const TOP_MENU_LANG_MODAL_OPEN_MP = "top_menu_lang_modal_open";

export const VIEW_CLAIM_STATUS_GTM = ["TopMenu", "clicked", "CheckYourCompensation"];
export const VIEW_CLAIM_STATUS_MP = "top_menu_view_claim_status";

export const TOP_BANNER_CHECK_COMPENSATION_GTM = ["TopBanner", "clicked", "CheckYourCompensation"];
export const TOP_BANNER_CHECK_COMPENSATION_MP = "top_banner_check_compensation";

export const BOTTOM_BAR_CHECK_COMPENSATION_GTM = ["BottomBar", "clicked", "CheckYourCompensation"];
export const BOTTOM_BAR_CHECK_COMPENSATION_MP = "bottom_bar_check_compensation";

export const BOTTOM_BAR_AIRHELP_PLUS_GTM = ["BottomBar", "clicked", "AirhelpPlus"];

export const HERO_BARCODE_SCANNER_GTM = ["Hero", "clicked", "CheckYourCompensationBarcode"];
